import { render, staticRenderFns } from "./carousel.pug?vue&type=template&id=3cdf0bfd&lang=pug&external"
import script from "./carousel.js?vue&type=script&lang=js&external"
export * from "./carousel.js?vue&type=script&lang=js&external"
import style0 from "./carousel.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports